import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { IMaskInput } from 'react-imask';

// Este é um componente adaptador para o IMaskInput que permite encaminhar ref corretamente
const IMaskInputAdapter = forwardRef((props: any, ref) => {
  // Usando HTMLInputElement para tipar o inputRef corretamente
  const inputRef = useRef<HTMLInputElement | null>(null);

  // Expor o método focus() e outros métodos relevantes para o React Hook Form
  useImperativeHandle(ref, () => ({
    focus: () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
    // Outros métodos que o React Hook Form pode precisar
    blur: () => {
      if (inputRef.current) {
        inputRef.current.blur();
      }
    },
    // Garantir que o DOM nativo esteja disponível
    get value() {
      return inputRef.current ? inputRef.current.value : '';
    },
    set value(val) {
      if (inputRef.current) {
        inputRef.current.value = val;
      }
    }
  }));

  return (
    <IMaskInput
      {...props}
      inputRef={inputRef}
    />
  );
});

// Adicionar um nome de exibição para o componente para facilitar a depuração
IMaskInputAdapter.displayName = 'IMaskInputAdapter';

export default IMaskInputAdapter;
